var map = {
	"@customer-profile/customer-profile.module.ngfactory": [
		"bXUL",
		1
	],
	"@global/global.module.ngfactory": [
		"FRt2",
		2
	],
	"@legal-info/legal-info.module.ngfactory": [
		"JGS3",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "crnd";
module.exports = webpackAsyncContext;